import React from 'react';
import { Header } from 'semantic-ui-react';

const PageHeader = props => {
	return <Header as="h1" className="campaign-title">{props.children}</Header>
}
export default PageHeader;